import { HFlow, isEmpty, Text, VFlow } from 'bold-ui'
import { stringGrouper } from 'util/string/string-grouper'
import { VacinacaoDirtyFieldsModel } from 'view/atendimentos/detail/vacinacao/model-vacinacao'

interface DirtyFieldsVacinacaoModalProps {
  readonly dirtyFields: VacinacaoDirtyFieldsModel
  readonly canHaveCondicaoMaternal: boolean
}

export function DirtyFieldsVacinacaoModal(props: DirtyFieldsVacinacaoModalProps) {
  const { dirtyFields, canHaveCondicaoMaternal } = props

  return (
    <VFlow vSpacing={0}>
      {!isEmpty(dirtyFields.imunobiologicos) && (
        <HFlow hSpacing={0.25}>
          <Text fontWeight='bold'>Imunobiológicos: </Text>
          <Text>{Array.from(dirtyFields.imunobiologicos).join(' | ')}</Text>
        </HFlow>
      )}
      {dirtyFields.condicaoMaternal && (
        <HFlow hSpacing={0.25}>
          <Text fontWeight='bold'>Condição maternal: </Text>
          <Text>{dirtyFields.condicaoMaternal}</Text>
        </HFlow>
      )}
      {!isEmpty(dirtyFields.outrasCondicoes) && (
        <HFlow hSpacing={0.25}>
          <Text fontWeight='bold'>{canHaveCondicaoMaternal ? 'Condições: ' : 'Outras condições: '}</Text>
          <Text>{stringGrouper(...dirtyFields.outrasCondicoes)}</Text>
        </HFlow>
      )}
    </VFlow>
  )
}
